import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';

interface SecurityFeaturesProps {
  showAutopass?: boolean;
}

export default function SecurityFeatures({ showAutopass }: SecurityFeaturesProps) {
  const { t } = useTranslation('createNote');

  return (
    <div className="flex items-start space-x-4 text-gray-600">
      <Shield className="w-6 h-6 flex-shrink-0 text-blue-500" />
      <div className="text-sm">
        <p className="font-medium text-gray-900 mb-1">{t('form.security.title')}</p>
        <ul className="list-disc list-inside space-y-1">
          <li>{t('form.security.features.encryption')}</li>
          <li>{t('form.security.features.expiration')}</li>
          <li>{t('form.security.features.password')}</li>
          <li>{t('form.security.features.oneTime')}</li>
          {showAutopass && (
            <li>{t('form.security.features.autopass')}</li>
          )}
        </ul>
      </div>
    </div>
  );
}